import { render, staticRenderFns } from "./ConfrimEraseModalKit.vue?vue&type=template&id=2ebe19b4&scoped=true&"
import script from "./ConfrimEraseModalKit.vue?vue&type=script&lang=js&"
export * from "./ConfrimEraseModalKit.vue?vue&type=script&lang=js&"
import style0 from "./ConfrimEraseModalKit.vue?vue&type=style&index=0&id=2ebe19b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebe19b4",
  null
  
)

export default component.exports